import type { PipelineCard, PipelineTone } from '@/pages/pipelines/common/types';

export type PipelineCardPresentation = Pick<
  PipelineCard,
  'badges' | 'title' | 'titleTone' | 'variant' | 'mixedTone'
> & {
  accentTone: PipelineTone;
  mixedTone: boolean;
};

export const getPipelineCardPresentation = (card: PipelineCard): PipelineCardPresentation => ({
  title: card.title,
  variant: card.variant ?? 'default',
  titleTone: card.titleTone ?? 'default',
  accentTone: card.accentTone ?? 'default',
  mixedTone: card.mixedTone ?? false,
  badges: card.badges,
});

export const getPipelineCardFaceIndicators = (card: PipelineCard) =>
  card.indicators.filter((indicator) => indicator.active);
